import { setPersonalizedQuestionsProgressAction } from "../../../../../redux/actions/productAction";

export const handleSelectedLogoOption = (
  selectedId,
  question,
  options,
  dispatch,
  progressState,
  setState,
  dependedFields
) => {
  console.info("logooptions", question);
  if (question !== "Options pour logo") return;

  const foundLogoOptionsDependedField =
    dependedFields && dependedFields.find(d => d.dependedOn === "logoMode");

  if (foundLogoOptionsDependedField) {
    let quesDetailID =
      foundLogoOptionsDependedField.quesDetails &&
      foundLogoOptionsDependedField.quesDetails[0] &&
      foundLogoOptionsDependedField.quesDetails[0].detailID;

    setState({ [quesDetailID]: "" });
  }

  console.info(
    "options22",
    options,
    dependedFields,
    foundLogoOptionsDependedField
  );
  let selectedOption = options.find(opt => opt.detailID === selectedId);

  let detailDesc = selectedOption && selectedOption.detailDesc;

  let logoMode = determineTheLogoMode(detailDesc);

  let existingLogoOption = {};
  if (logoMode === "existingLogo") {
    const option = options.find(opt => opt.detailDesc === "Logo au dossier");
    if (option) existingLogoOption = option;
  }

  dispatch(
    setPersonalizedQuestionsProgressAction({
      logo: { ...progressState.logo, logoMode, existingLogoOption }
    })
  );
};

export const determineTheLogoMode = detailDesc => {
  let logoMode = "";
  if (detailDesc === "Aucun logo") {
    logoMode = "";
  } else if (detailDesc === "Téléverser mon logo") {
    logoMode = "uploadLogo";
  } else if (detailDesc === "Logo en Clipart") {
    logoMode = "pickClipart";
  } else if (detailDesc === "Logo au dossier") {
    logoMode = "existingLogo";
  } else {
    logoMode = "";
  }

  return logoMode;
};
